<template>
<div class="chapter">
<div class="inner_page">
<h1 class="title1">Burnt Offering</h1>
<p class="title2">A Captain Heimrich Mystery</p>
<p class="title3">FRANCES AND RICHARD LOCKRIDGE</p>
<div class="img_container1">
<img alt="image" src="images/logo3.jpg"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Title.vue?6f5d95e9